import Toggle from "@/components/toggle/toggle.vue";
import { createNamespacedHelpers } from "vuex";

const { mapGetters: userGetters } = createNamespacedHelpers("user");

export default {
	model: { event: "change" },

	props: {
		value: Boolean,
		weightLabel: {
			type: String,
			// if you need grams pass weightLabel="gr" on the component
			default: "kg",
		},
	},

	components: { Toggle },

	watch: {
		isCostToggleActive(value) {
			this.$ma.trackEvent({
				action: "Weight / price Toggle",
				properties: {
					Value: this.isCostToggleActive ? "Price" : "Weight",
					Component: this.$route.name,
				},
			});
			this.$emit("change", value);
		},
	},

	data() {
		return { isCostToggleActive: false };
	},

	created() {
		this.isCostToggleActive = this.value;
	},

	computed: { ...userGetters(["activeOutlet", "weightUnit", "weightUnitMinor"]) },
};
